import React from "react"
import type { Locale } from "popopo-msg/routes"
import { MobileAppBanner } from "./MobileAppBanner"

export type MobileAppBannerProps = {
  appIconUrl: string
  onOpen: () => void
}

interface SimplePageProps {
  locale: Locale
  mobileAppBanner?: MobileAppBannerProps
  children: React.ReactNode
}

export const SimplePage: React.FC<SimplePageProps> = ({
  locale,
  mobileAppBanner,
  children,
}) => {
  return (
    <div className={`simple-page${mobileAppBanner ? " simple-page--with-banner" : ""}`}>
      {mobileAppBanner && (
        <MobileAppBanner
          locale={locale}
          appIconUrl={mobileAppBanner.appIconUrl}
          onOpen={mobileAppBanner.onOpen}
        />
      )}
      <div className="simple-page__container">
        <div className="simple-page__content">
          {children}
        </div>
      </div>
    </div>
  )
}
